import { render, staticRenderFns } from "./VEmployeesBrowse.vue?vue&type=template&id=4e6128de&scoped=true&lang=pug"
import script from "./VEmployeesBrowse.vue?vue&type=script&lang=ts"
export * from "./VEmployeesBrowse.vue?vue&type=script&lang=ts"
import style0 from "./VEmployeesBrowse.vue?vue&type=style&index=0&id=4e6128de&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6128de",
  null
  
)

/* custom blocks */
import block0 from "./VEmployeesBrowse.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fpages%2FLayout%2Fviews%2FExpert%2Fviews%2FEmployees%2Fbrowse%2FVEmployeesBrowse.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports